export const retirarMascaraCnpj = (valor) => {
    const cnpj = valor;
    const cnpjSemMascara = cnpj.replace(/[^\d]/g, '');

    return cnpjSemMascara;
};
